<template>
  <div class="referral-wrap mt-3">
    <div class="title">Referral</div>
    <div class="box-ref">
      <div v-if="isLoading" class="desc-info">
        <b-skeleton width="60%"></b-skeleton>
      </div>
      <div class="desc-info" v-if="codeRef">
        {{ `Boost your earnings by sharing referral code with others.` }}
      </div>
      <div v-else class="desc-info">
        {{ `Increase your earnings by applying the referral code '${code}'` }}
      </div>
      <div v-if="isLoading" class="desc-info">
        <b-skeleton width="30%" type="button"></b-skeleton>
      </div>
      <div v-else class="box-form-ref">
        <div v-if="myCode.length === 0" class="apply-code">
          <div class="ref-label">Referral Code:</div>
          <div class="ref-form">
            <b-form-input
              class="txt-code"
              id="input-1"
              v-model="code"
              type="text"
              placeholder="Referral Code"
              required
            ></b-form-input>
            <b-overlay
              :show="isApplied"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <b-btn
                :disabled="code.length === 0"
                class="btn-apply px-4"
                @click="onApply"
                >Apply
              </b-btn>
            </b-overlay>
          </div>
        </div>
        <div v-else>
          <div class="invite">
            <div class="i-label">Invite Link:</div>
            <div ref="myLink" :a-value="`${baseUrl}/?code=${myCode}`">
              {{ utils.truncate(`${baseUrl}/?code=${myCode}`, 24) }}
            </div>
            <div v-if="copied.myLink" class="copied">Copied</div>
            <div v-else @click="clipboard('myLink')" class="copy"></div>
          </div>
          <div class="invite">
            <div class="i-label">Invite Code:</div>
            <div ref="myCode" :a-value="myCode">{{ myCode }}</div>
            <div class="copied" v-if="copied.myCode">Copied</div>
            <div v-else @click="clipboard('myCode')" class="copy"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="bonus-modal"
      title="Extra Bonus"
      body-class="modal-extral-body"
      footer-class="modal-extral-footer"
      centered
    >
      <template #default>
        <p class="extral-desc" v-if="codeRef">
          {{ `Boost your earnings by sharing referral code with others.` }}
        </p>
        <p v-else class="extral-desc">
          {{ `Increase your earnings by applying the referral code '${code}'` }}
        </p>
      </template>
      <template #modal-footer>
        <div class="modal-f-wrap">
          <label for="input-2" class="m-label">Referral Code:</label>
          <div class="row-input">
            <b-form-input
              class="m-code"
              id="input-2"
              v-model="code"
              type="text"
              placeholder="Referral Code"
              required
            ></b-form-input>
            <div class="row-action">
              <b-overlay
                :show="isApplied"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block o-apply mr-2"
              >
                <b-btn class="btn-m-custom btn-m-apply" @click="onApply">
                  Apply
                </b-btn>
              </b-overlay>
              <b-btn class="btn-m-custom btn-m-skip ml-2" @click="onSkip">
                Skip
              </b-btn>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { Referral } from "@/amakunicom/sdk";
import { ethers } from "ethers";
export default {
  data: () => ({
    myCode: "",
    baseUrl: window.location.origin,
    codeRef: "",
    rate: ethers.constants.Zero,
    isLoading: true,
    code: "",
    isApplied: false,
    copied: {
      myLink: false,
      myCode: false,
    },
  }),
  async created() {
    this.signer = await this.provider.getSigner();
    this.account = await this.signer.getAddress();
    const tokens = this.getCoreConfig();
    this.referral = await Referral.initWith(
      tokens.referral,
      this.provider,
      this.signer
    );

    this.loadData();
  },
  methods: {
    onSkip() {
      this.$bvModal.hide("bonus-modal");
      this.mStore.saveExtralBonus(this.account);
    },
    async loadData() {
      let codes;
      [this.codeRef, codes, this.rate] = await this.referral.myCodes(
        this.account
      );
      if (codes && codes.length > 0) {
        this.myCode = codes[codes.length - 1];
      }
      if (!this.codeRef) {
        this.code = this.$route.query.code || "AMAKUNI";
        if (!this.mStore.statusExtralBonus(this.account)) {
          this.$bvModal.show("bonus-modal");
        }
      }
      if (this.myCode) {
        this.mStore.setMyRef(this.myCode);
      }
      this.isLoading = false;
    },
    async onApply() {
      this.isApplied = true;
      try {
        await (await this.referral.applyCode(this.code)).wait();
        await this.loadData();
        this.$bvModal.hide("bonus-modal");
        this.$bvToast.show("tx-success");
      } catch (err) {
        this.$bvToast.toast(
          err.reason || err.message || "KUNI: Unable to process request",
          {
            variant: "warning",
            autoHideDelay: 2000,
            title: "Warning",
          }
        );
      }
      this.isApplied = false;
    },
    clipboard(_ref) {
      const element = this.$refs[_ref];
      const self = this;
      this.$clipboard(element.getAttribute("a-value"))
        .then(() => {
          self.copied[_ref] = true;
          setTimeout(() => {
            self.copied[_ref] = false;
          }, 1000);
        })
        .catch(() => {
          this.$bvToast.toast("error");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.referral-wrap {
  background-color: transparent;
  padding-bottom: 32px;
  .box-ref {
    padding: 0 58px;
  }
  .title {
    max-width: 425px;
    // background: linear-gradient(
    //   90deg,
    //   rgb(71 47 107 / 58%) 0%,
    //   rgba(71, 47, 107, 0) 25%
    // );
    background: linear-gradient(90deg, #472f6b 0%, rgba(71, 47, 107, 0) 100%);

    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 37px;
    padding: 6px 0 6px 58px;
    margin-bottom: 12px;
  }

  .desc-info {
    // padding-left: 58px;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.32px;
    margin-bottom: 12px;
    @media (max-width: 767px) {
      padding-left: 16px;
    }
  }
  .box-form-ref {
    @media (max-width: 767px) {
      margin-left: 16px;
    }
  }

  .invite {
    // padding-left: 58px;
    margin-top: 6px;
    color: #fff;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    .i-label {
      font-weight: 600;
      overflow: hidden;
      min-width: 112px;
      display: inline-block;
    }
    .copy {
      width: 16px;
      height: 18px;
      background: url("~@/assets/icons/copy.svg");
      margin-left: 12px;
      cursor: pointer;
      animation: fadeIn 0.5s;
    }
    .copied {
      margin-left: 8px;
      color: #eb345f;
      text-transform: lowercase;
      animation: fadeIn 0.5s;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }

  .apply-code {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    .ref-form {
      display: flex;
      gap: 10px;
    }
    .ref-label {
      color: var(--White, #fff);
      font-family: Source Sans Pro;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    .txt-code {
      color: var(--White, #fff);
      display: flex;
      text-align: center;
      width: 235px;
      padding: 7px 13px;
      justify-content: center;
      align-items: center;
      gap: 6px;
      border-radius: 2px;
      background-color: transparent;
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
    .btn-apply {
      padding: 5px 13px;
      border-radius: 2px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background: var(--Red, #eb345f);
      gap: 6px;
      &:active,
      &:focus {
        box-shadow: none;
      }
    }
    @media (max-width: 576px) {
      .txt-code {
        width: 100%;
      }
    }
  }

  .extral-desc {
    color: white;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 24px;
    padding: 8px 32px;
  }
  @media (max-width: 767px) {
    .title {
      font-size: 24px;
      padding-left: 20px;
    }
    .box-ref {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  @media (max-width: 400px) {
    .apply-code {
      .txt-code {
        width: 200px;
      }
    }
  }
}
#bonus-modal {
  .modal-body {
    .extral-desc {
      font-size: 16px;
      font-style: italic;
      line-height: 24px;
    }
  }
}
</style>
